import { render, staticRenderFns } from "./Swiper.vue?vue&type=template&id=7a60fde0&"
import script from "./Swiper.vue?vue&type=script&lang=ts&"
export * from "./Swiper.vue?vue&type=script&lang=ts&"
import style0 from "./Swiper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports